module.exports = __webpack_public_path__ + "img/bright-harvest.77ca0668.webp";